var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-dropdown',{attrs:{"id":_vm.id,"text":_vm.label,"variant":_vm.variant}},_vm._l((_vm.actions.actions),function(action){return _c('b-dropdown-item',{key:action.id},[_vm._v(" "+_vm._s(action.text)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }